import { EnumProcessorSchedulingStatus } from 'lib/graphql';

/** Responsive grid layout for order/job card grids. */
export const orderCardGridSx = {
  display: 'grid',
  gridTemplateColumns: '1fr',
  '@media (min-width: 964px)': {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  '@media (min-width: 1200px)': {
    gridTemplateColumns: 'repeat(3, 1fr)',
  },
  gap: 2,
} as const;

/** Human-readable labels for ProcessorScheduling status values. */
export const STATUS_DISPLAY: Record<string, string> = {
  [EnumProcessorSchedulingStatus.Requested]: 'Requested',
  [EnumProcessorSchedulingStatus.Scheduled]: 'Scheduled',
  [EnumProcessorSchedulingStatus.DroppedOff]: 'Dropped Off',
  [EnumProcessorSchedulingStatus.Killed]: 'Killed',
  [EnumProcessorSchedulingStatus.Aging]: 'Aging',
  [EnumProcessorSchedulingStatus.Curing]: 'Curing',
  [EnumProcessorSchedulingStatus.Invoicing]: 'Invoicing',
  [EnumProcessorSchedulingStatus.ReadyPayAtPickup]: 'Ready - Pay at Pickup',
  [EnumProcessorSchedulingStatus.InvoicePaid]: 'Invoice Paid',
  [EnumProcessorSchedulingStatus.Completed]: 'Completed',
  [EnumProcessorSchedulingStatus.CancelledByProcessor]:
    'Cancelled by Processor',
  [EnumProcessorSchedulingStatus.CancelledByProducer]: 'Cancelled by Producer',
  [EnumProcessorSchedulingStatus.DeniedByProcessor]: 'Denied by Processor',
};
